module.exports = __webpack_public_path__ + "static/media/upload.8208e1f0.svg";